module.exports = __webpack_public_path__ + "static/2-bb7c81a641049d49083aa42c1469df3f.jpg";